import { put, takeEvery, call } from 'redux-saga/effects';

import * as apis from '../../network/apis/trips';
import {
  getTripsDetailsRequest,
  getTripsDetailsResponse,
  getTripsListResponse,
} from './slice';
import { showSnackMsg } from '../../utils/Helpers';
import { setCanShowEmptyState, setSkeletonObject } from '../Loader/slice';

export function* getTripsListSaga({ payload }) {
  try {
    yield put(getTripsListResponse({}));
    yield put(setSkeletonObject({ field: 'table', value: true }));
    const response = yield call(apis.getTrips, payload);
    const meta = {
      currentPage: +response.headers['current-page'],
      count: +response.headers['total-count'],
      pages: +response.headers['total-pages'],
      totalTrips: +response.headers['total-count'],
      totalOngoingTrips: response.data.total_ongoing_trips_count,
      totalEndedTrips: response.data.total_ended_trips_count,
      totalCoveredKms: response.data.total_covered_kms,
    };
    const trips = response.data?.trips;
    yield put(getTripsListResponse({ trips, meta }));
    yield put(setSkeletonObject({ field: 'table', value: false }));
    if (trips.length === 0) {
      yield put(setCanShowEmptyState(true));
    } else {
      yield put(setCanShowEmptyState(false));
    }
  } catch (err) {
    yield put(setSkeletonObject({ field: 'table', value: false }));
    yield put(setCanShowEmptyState(true));
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export function* getTripDetailsSaga({ payload }) {
  try {
    yield put(setSkeletonObject({ field: 'trips', value: true }));
    const response = yield call(apis.getTripDetails, payload);
    const trip = response?.data?.trip;
    yield put(getTripsDetailsResponse(trip));
    yield put(setSkeletonObject({ field: 'trips', value: false }));
    if (!trip) {
      yield put(setCanShowEmptyState(true));
    } else {
      yield put(setCanShowEmptyState(false));
    }
  } catch (err) {
    yield put(setSkeletonObject({ field: 'trips', value: false }));
    yield put(setCanShowEmptyState(true));
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export function* forceEndTripSaga({ payload }) {
  try {
    yield put(setSkeletonObject({ field: 'trips', value: true }));
    yield call(apis.forceEndTrip, payload.id);
    yield put(getTripsDetailsRequest(payload.id));
    yield showSnackMsg(payload.successMsg, 'success');
    yield put(setSkeletonObject({ field: 'trips', value: false }));
    yield put(setCanShowEmptyState(false));
  } catch (err) {
    yield put(setSkeletonObject({ field: 'trips', value: false }));
    yield put(setCanShowEmptyState(true));
    yield put(getTripsDetailsRequest(payload.id));
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export default function* TripsSagas() {
  yield takeEvery('trips/getTripsListRequest', getTripsListSaga);
  yield takeEvery('trips/getTripsDetailsRequest', getTripDetailsSaga);
  yield takeEvery('trips/forceEndTripRequest', forceEndTripSaga);
}
